import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box } from "@mui/material";

const GeneratedImagePreview = ({ handleInputChange, pendingFile, previewImage, isModalOpen, onConfirmPreview, onClosePreview }) => {


    const handleConfirmImage = () => {
        if (pendingFile) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(pendingFile);
            const fileList = dataTransfer.files;

            // Pass to handleInputChange
            handleInputChange({ target: { files: fileList }, generated: true });

            // Cleanup
            onConfirmPreview();
        }
    };

    const handleCancelImage = () => {
        onClosePreview();
    };

    return (
        <>
            {/* AI Image Preview Dialog */}
            <Dialog open={isModalOpen} onClose={handleCancelImage}>
                <DialogTitle>Preview AI-Generated Image</DialogTitle>
                <DialogContent>
                    {previewImage && (
                        <Box
                            component="img"
                            src={previewImage}
                            alt="Generated Preview"
                            sx={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelImage} color="error">Cancel</Button>
                    <Button onClick={handleConfirmImage} color="primary" variant="contained">Confirm</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default GeneratedImagePreview;
